export enum ProjectType {
  MOBILE,
  TABLET
}

export enum LinkType {
  EXTERNAL,
  INTERNAL,
  NO_BUTTON,
}

export interface Project {
  name: string
  sub: string
  type: ProjectType
  linkType: LinkType
  imageUrl: string
  bgUrl: string
  bgPos?: string
  urls: {
    android?: string,
    web?: string
    webText?: string
    inProgress?: string
  }
}

const projects: Project[] = [
  {
    name: "Mailpay.cz",
    sub: "Levná platební brána pomocí QR kódů",
    type: ProjectType.TABLET,
    linkType: LinkType.EXTERNAL,
    imageUrl: "/img/screens/mailpay.png",
    bgUrl: "/img/bgs/mailpay.png",
    urls: {
      web: "https://mailpay.cz?ref=puhony.eu",
    }
  },
  {
    name: "Pixeland",
    sub: "Svět nové interaktivní zábavy přichází do Hradce Králové!",
    type: ProjectType.TABLET,
    linkType: LinkType.EXTERNAL,
    imageUrl: "/img/screens/pixeland2.png",
    bgUrl: "/img/bgs/pixel.jpeg",
    urls: {
      web: "https://pixeland.cz/",
    }
  },
  {
    name: "Steller",
    sub: "Cestovatelské příběhy pro dobrodruhy - web (spolupráce NEXTAP)",
    type: ProjectType.TABLET,
    linkType: LinkType.EXTERNAL,
    imageUrl: "/img/screens/steller.png",
    bgUrl: "/img/bgs/surf.jpg",
    bgPos: "top center",
    urls: {
      web: "https://steller.cz/",
    }
  },
  {
    name: "Canvass",
    sub: "Hlasuj na otázky dne, zjisti co si myslí ostatní. (spolupráce NEXTAP)",
    type: ProjectType.TABLET,
    linkType: LinkType.EXTERNAL,
    imageUrl: "/img/screens/canvass.png",
    bgUrl: "/img/bgs/odissei-e1YThDHmTA4-unsplash.jpg",
    urls: {
      web: "https://canvass.vote/"
    }
  },
  {
    name: "Závod-IS",
    sub: "Webová aplikace pro skautské závody",
    type: ProjectType.MOBILE,
    linkType: LinkType.EXTERNAL,
    imageUrl: "/img/screens/zavody.png",
    bgUrl: "/img/bgs/jamie-street-_94HLr_QXo8-unsplash.jpg",
    urls: {
      web: "https://zavody.app.skautstezery.cz/",
    }
  },
  {
    name: "E-voucher",
    sub: "Prodejní platforma poukazů",
    type: ProjectType.TABLET,
    linkType: LinkType.EXTERNAL,
    imageUrl: "/img/screens/evoucher.png",
    bgUrl: "/img/bgs/gift.jpg",
    urls: {
      web: "https://e-voucher.cz/eshop/lg-hk",
    }
  },
  {
    name: "Skaut stěžery",
    sub: "Web pro skautské středisko",
    type: ProjectType.TABLET,
    linkType: LinkType.EXTERNAL,
    imageUrl: "/img/screens/skaut2.png",
    bgUrl: "/img/bgs/camp.jpg",
    bgPos: "top center",
    urls: {
      web: "https://skautstezery.cz/"
    }
  },
  {
    name: "ČVUT MENZA",
    sub: "Aplikace pro hladovějící studenty. (Vývoj aplikace byl pozastaven.)",
    type: ProjectType.MOBILE,
    linkType: LinkType.NO_BUTTON,
    imageUrl: "/img/screens/cvut-menza.webp",
    bgUrl: "/img/bgs/fit.jpeg",
    urls: {}
  },
  {
    name: "Laser Game HK",
    sub: "Webová prezentace a rezervační systém",
    type: ProjectType.TABLET,
    linkType: LinkType.EXTERNAL,
    imageUrl: "/img/screens/lg.png",
    bgUrl: "/img/bgs/lg.jpeg",
    urls: {
      web: "http://lasergame-hk.cz/",
    }
  },
  {
    name: "Locate.io",
    sub: "Systém pro pasivní lokalizaci wifi zařízení v reálném čase!",
    type: ProjectType.TABLET,
    linkType: LinkType.EXTERNAL,
    imageUrl: "/img/screens/locateio.png",
    bgUrl: "/img/bgs/samsung-gc2646c102_640.jpg",
    urls: {
      web: "https://b2017puhoma.delta-www.cz/maturita/dokumentace/puhony_SOC_final.pdf",
      webText: "Dokumentace"
    }
  },
  {
    name: "Tanix",
    sub: "Správa IoT zařízení (ve spolupráci s DAMIDEV)",
    type: ProjectType.TABLET,
    linkType: LinkType.EXTERNAL,
    imageUrl: "/img/screens/tanix.png",
    bgUrl: "/img/bgs/warehouse.jpg",
    urls: {
      web: "https://tanix.cz",
      webText: "Web"
    }
  },
  {
    name: "Crowning arts",
    sub: "Komunitní sociální síť pro sdílení umění. (ve spolupráci s DAMIDEV)",
    type: ProjectType.TABLET,
    linkType: LinkType.NO_BUTTON,
    imageUrl: "/img/screens/ca.png",
    bgUrl: "/img/bgs/gallery.jpg",
    urls: {}
  },
  {
    name: "BurzaŠkol.Online",
    sub: "Online náhrada za výstavy škol",
    type: ProjectType.TABLET,
    linkType: LinkType.EXTERNAL,
    imageUrl: "/img/screens/burza.png",
    bgUrl: "/img/bgs/delta.webp",
    urls: {
      web: "https://www.delta-skola.cz/informacni-system-burzaskol-online-2021",
      webText: "Článek o projektu"
    }
  },
  {
    name: "Zápis do první třídy",
    sub: "Online zápisy pro Ústí nad Orlicí",
    type: ProjectType.TABLET,
    linkType: LinkType.EXTERNAL,
    imageUrl: "/img/screens/zapisdoprvnitridy.png",
    bgUrl: "/img/bgs/school.jpg",
    urls: {
      web: "https://zapisdoprvnitridy.cz",
    }
  },
]

export default projects
